import React from 'react';
import ExportModalContentRange from '../DefaultExportModal/ExportModalContentRange';

function ChemquoteExportModalContent(props) {
  return (
    <div className="exportModal__content">
      <ExportModalContentRange {...props} />
    </div>
  );
}

export default ChemquoteExportModalContent;
